import { Pipe, PipeTransform } from '@angular/core';

import { temperaturas } from '../temperatura';

@Pipe({
    name: 'temperaturaImage'
})
export class TemperaturaImagePipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = temperaturas.findIndex(temperatura => temperatura.id === value);
        if (index > -1) {
            return temperaturas[index].imageSrc;
        }
        return '';
    }
}
